import * as React from 'react';
import { Typography, Box } from '@material-ui/core';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { getFormikValidator } from '../../utils/getFormikValidator';
import RenderText from '../../dictionaries/RenderText';
import useDictionary from '../../dictionaries/context/useDictionary';
import FormikSelectInput from '../../components/FormikInputWrappers/FormikSelectInput';
import { IdentificationConfirmationStyles } from '../IdentificationConfirmation/IdentificationConfirmationStyles';
import Btn from '../../components/Btn/Btn';
import FormikTextField from '../../components/FormikInputWrappers/FormikTextField';

interface DebtNegPreApprovedNoAuthProps {
  baseClasses: IdentificationConfirmationStyles;
}

const initialValues = { document: '', documentType: 'national_id' };
const validate = getFormikValidator({ document: 'required' }, { document: 'documento' });

const DebtNegPreApprovedNoAuth: React.FC<DebtNegPreApprovedNoAuthProps> = ({ baseClasses }) => {
  const history = useHistory();
  const { gT } = useDictionary();

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit: ({ document }) => {
      history.push(`/simple/${document}`);
    },
  });

  return (
    <>
      <Typography className={baseClasses.title} data-test="cy-generalNoAuthTitle-text">
        <RenderText textKey="general_no_auth_title" isMarkdown />
      </Typography>
      <Typography className={baseClasses.description}>
        <RenderText textKey="general_no_auth_description" />
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Box display="flex" flexDirection="column" alignItems="flex-start" className="mb-1" width="100%">
          <FormikSelectInput
            label={gT('general_no_auth_select_label')}
            className="selectDocument mt-4 mb-2"
            formik={formik}
            fullWidth
            valueId="documentType"
            options={[
              {
                label: gT('general_no_auth_select_option_C'),
                value: 'national_id',
              },
              {
                label: gT('general_no_auth_select_option_E'),
                value: 'foreign_id',
              },
              {
                label: gT('general_no_auth_select_option_N'),
                value: 'nit',
              },
            ]}
            data-test="cy-documentValidation-select"
          />
          <FormikTextField
            className="mb-4"
            formik={formik}
            valueId="document"
            fullWidth
            disableAutoComplete
            placeholder={gT('general_no_auth_input_placeholder')}
            data-testid="debt-neg-preapproved-no-auth__document-validation-input"
          />
          <Box display="flex" justifyContent="flex-end" width="100%">
            <Btn
              variant="contained"
              color="primary"
              type="submit"
              data-testid="debt-neg-preapproved-no-auth__document-validation-button"
            >
              <RenderText textKey="general_no_auth_button" />
            </Btn>
          </Box>
        </Box>
      </form>
    </>
  );
};

export default DebtNegPreApprovedNoAuth;
